import React from "react";
import ListViewHeader from "./ListViewHeader";
import { ListViewContainer, ListViewItem } from "../components";
import { useTasks } from "../contexts/tasks-context";
import { Loader } from "@td/ui";

const ListView = React.memo(() => {
  const { tasks, loading, initializing } = useTasks();

  return (
    <ListViewContainer>
      <ListViewHeader />

      {tasks.map((task) => <ListViewItem key={task.id} task={task} />)}

      {(initializing || loading) && (
        <Loader />
      )}
    </ListViewContainer>
  );
});

export default ListView;
